/**
 * Cancels a specified setTimeout() call.
 * @param	id	The ID of the setTimeout() call, which you set to a variable,
 *   as in the following:
 * @langversion	3.0
 * @playerversion	Flash 9
 */
/**
 * Cancels a specified setTimeout() call.
 * @param	id	The ID of the setTimeout() call, which you set to a variable,
 *   as in the following:
 * @langversion	3.0
 * @playerversion	Flash 9
 */ export var clearTimeout = window.clearTimeout;
